import axios from "axios";
import React, { useRef } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import fundo from "../../../../styles/fundo.svg";



const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;
  box-shadow: 0px 0px 2px #ccc;
  padding: 10px;
`;

const Div = styled.div`
  width:97%;
  background-color:#f4f4f5;
  display: flex; 
  padding: 10px 10px;
  align-items: flex-end;
  gap: 20px 0px;
  flex-direction: row;
 
`;


const TextAreaContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  
  textarea{
    font-size: 18px;
    width: 490px;
    height: 100px;
    background-color: #f4f4f5;
    border: 1px solid #ccc;
    border-radius: 10px; 
    color:#3a3f42;
    padding: 5px;
  }


`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  


`;


const InputTitle = styled.input`
  width: 480px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  color:#3a3f42;
  font-size: 18px;
`;

const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  margin: 0px 5px;

  @media (max-width: 500px) {
    font-size: 16px;
  }
`;



const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;


const Form = ({ urlApi, modalNovoQuadro, fetchQuadro }) => {

  const ref = useRef();

  //Token da api
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');






  //--------------------------FUNÇÂO QUE SALVA OS QUADROS NO BANCO-------------------------------------//
  const handleCriarQuadro = async (e) => {
    e.preventDefault();
    const user = ref.current;


    const id_criadorValue = id;
    const titulo_quadroValue = user.titulo_quadro.value;
    const descricao_quadroValue = user.descricao_quadro.value;



    if (!titulo_quadroValue || !descricao_quadroValue) {
      return toast.warn("Preencha todos os campos!");
    }

    if (titulo_quadroValue.length > 50) {
      return toast.warn("O título não pode ultrapassar 50 caracteres.");
    }

    if (descricao_quadroValue.length > 255) {
      return toast.warn("A descrição não pode ultrapassar 255 caracteres.");
    } else {

      try {
        const requestData1 = {
          id_criador: id_criadorValue,
          titulo_quadro: titulo_quadroValue,
          descricao_quadro: descricao_quadroValue,
          livre: 'N'
        };

        await axios.post(`${urlApi}painel-monitoramento/add-quadro`, requestData1, { headers: { Authorization: `Bearer ${token}` } });

        toast.success("Quadro criado com sucesso!");

        setTimeout(function () {
          modalNovoQuadro()
        }, 1000);

        fetchQuadro();
      } catch (error) {
        console.error("Erro completo:", error);
        if (error.response) {
          const errorMessage = error.response.data.error;
          toast.error(errorMessage);
        } else {
          toast.error("Erro inesperado ao enviar dados.");
        }
      }

    }

  };







  return (
    <div >
      <FormContainer ref={ref} onSubmit={handleCriarQuadro}>


        <Div>
          <InputArea>
            <Label>Título:</Label>
            <InputTitle
              placeholder="Digite um título...."
              name="titulo_quadro"
              type="text"
            />
          </InputArea>
        </Div>


        <Div>
          <TextAreaContainer>
            <Label>Descrição:</Label>
            <textarea id="descricao_quadro" name="msg" placeholder="Digite uma descrição...."></textarea>
          </TextAreaContainer>
        </Div>






        <Div>
          <Button title="Salvar novo quadro" type="submit" >
            Criar quadro
          </Button>
        </Div>
      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div>

  );
};

export default Form;


